import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { CompanySearchCriteria } from '../../dto/copilot-search.dto';

@Injectable({
    providedIn: 'root'
})
export class SearchApiService {
    private readonly url: string = 'service/contactcloud/assisted-search';

    constructor(private readonly baseApiService: BaseApiService) { }

    getSearchCriteria(searchText: string): Observable<CompanySearchCriteria> {
        return this.baseApiService.post<CompanySearchCriteria>(`${this.url}`, { searchText });
    }

}
